/**
 * Returns the Location pathname in the local environment (which should be equivalent to the baseHref).
 * With the assumed url structure (environment/baseHref/#/route) pathname should have a preceding and following '/'.
 * In all other environments this returns '/'.
 */
export const baseHref = () =>
  window.location.hostname === 'localhost' ? window.location.pathname : '/';
